import { LTX_23_LORA_MODEL } from './lora-input-models.const';

export const MODEL_INPUT_LIMITS: Record<
  string,
  { maxInputs: number; inputPrefixes: string[]; handlesPerInput?: number; maxInputsByPrefix?: Record<string, number> }
> = {
  kling: { maxInputs: 3, inputPrefixes: ['element'] },
  rw_aleph2: { maxInputs: 5, inputPrefixes: ['keyframe'] },
  // 8, not 10: the endpoint's 10-frame cap also counts the Image and End Image frames.
  'blackforestlabs/flux-3/text-to-video': { maxInputs: 8, inputPrefixes: ['keyframe'] },
  // Fal caps image_urls at 10 on Flux 3 Image Edit.
  'blackforestlabs/flux-3/text-to-image': { maxInputs: 10, inputPrefixes: ['image'] },
  // Fal caps image_urls at 8 on Krea 3 Edit.
  'krea/v3/text-to-image': { maxInputs: 8, inputPrefixes: ['image'] },
  'fal-ai/kling-video/v2.6/standard/motion-control': { maxInputs: 1, inputPrefixes: ['element'] },
  'fal-ai/kling-video/v2.6/pro/motion-control': { maxInputs: 1, inputPrefixes: ['element'] },
  'kwaivgi/kling-v1.6-pro': { maxInputs: 4, inputPrefixes: ['reference_image'] },
  'fal-ai/flux-2-pro': { maxInputs: 8, inputPrefixes: ['image'] },
  'fal-ai/flux-2-flex': { maxInputs: 8, inputPrefixes: ['image'] },
  hyper_3d_rodin: { maxInputs: 5, inputPrefixes: ['image'] },
  'fal-ai/hyper3d/rodin/v2': { maxInputs: 5, inputPrefixes: ['image'] },
  // Fal uses only the first 4 images on Meshy 7.1 Multi-Image.
  'meshy/v7.1/multi-image-to-3d': { maxInputs: 4, inputPrefixes: ['image'] },
  'fal-ai/nano-banana/edit': { maxInputs: 10, inputPrefixes: ['image'] },
  'lyria-3': { maxInputs: 10, inputPrefixes: ['image'] },
  'fal-ai/nano-banana-2/edit': { maxInputs: 14, inputPrefixes: ['image'] },
  'fal-ai/nano-banana-2-lite/edit': { maxInputs: 14, inputPrefixes: ['image'] },
  'fal-ai/flux-2-max/edit': { maxInputs: 8, inputPrefixes: ['image'] },
  // Fal caps image_urls at 16 on both the Flare and Sunburst edit endpoints.
  'gpt-image-2.5': { maxInputs: 16, inputPrefixes: ['image'] },
  reve: { maxInputs: 4, inputPrefixes: ['reference_image'] },
  'reve-2.1-remix': { maxInputs: 8, inputPrefixes: ['reference_image'] },
  'fal-ai/kling-video/o1/video-to-video/reference': { maxInputs: 4, inputPrefixes: ['image'] },
  'fal-ai/kling-video/o1/video-to-video/edit': { maxInputs: 4, inputPrefixes: ['image'] },
  'fal-ai/kling-video/o3/pro/video-to-video/edit': {
    maxInputs: 4,
    inputPrefixes: ['image', 'element'],
  },
  'fal-ai/bytedance/seedream/v5/lite/edit': { maxInputs: 10, inputPrefixes: ['image'] },
  'bytedance/seedance-2.0/reference-to-video': { maxInputs: 10, inputPrefixes: ['reference'] },
  'bytedance/seedance-2.0/mini/reference-to-video': { maxInputs: 10, inputPrefixes: ['reference'] },
  'bytedance/seedance-2.5/reference-to-video': { maxInputs: 50, inputPrefixes: ['reference'] },
  'openrouter/router/video/enterprise': { maxInputs: 10, inputPrefixes: ['video'] },
  'alibaba/happy-horse/video-edit': { maxInputs: 5, inputPrefixes: ['image'] },
  'alibaba/happy-horse/reference-to-video': { maxInputs: 9, inputPrefixes: ['image'] },
  'google/gemini-omni-flash/reference-to-video': { maxInputs: 20, inputPrefixes: ['image'] },
  // 1.1 recommends up to 5 images and 3 videos; the combined cap stays 20 and Google rejects excess.
  'google/gemini-omni-flash-preview/reference-to-video': { maxInputs: 20, inputPrefixes: ['reference'] },
  // Fal caps images at 9, videos at 3, audio at 3, and all references combined at 12.
  'minimax/h3/reference-to-video': { maxInputs: 12, inputPrefixes: ['reference'] },
  // Fal caps images at 10, videos at 5, audio at 5; there is no documented combined cap.
  'alibaba/wan-3.0/reference-to-video': { maxInputs: 10, inputPrefixes: ['reference'] },
  'kling/v4/reference-to-video': {
    maxInputs: 22,
    inputPrefixes: ['reference', 'element'],
    maxInputsByPrefix: { reference: 15, element: 7 },
  },
  'kling/v4/video-to-video/edit': {
    maxInputs: 17,
    inputPrefixes: ['reference', 'element'],
    maxInputsByPrefix: { reference: 10, element: 7 },
  },
  // Fal caps reference_image_urls at 4, or 3 with a mask; the server rejects the 4th when a mask is connected.
  'ideogram/v4.5/edit': { maxInputs: 4, inputPrefixes: ['reference'] },
  'bytedance/seed-audio-1.0': { maxInputs: 3, inputPrefixes: ['audio'] },
  world_labs_01: { maxInputs: 5, inputPrefixes: ['image'] },
  // Each LoRA is two handles (`lora_N` + `lora_N_scale`); Fal caps the `loras` array at 3.
  [LTX_23_LORA_MODEL]: { maxInputs: 3, inputPrefixes: ['lora'], handlesPerInput: 2 },
  // Add more models here as needed:
  // 'another-model-name': { maxInputs: 6, inputPrefixes: ['some_prefix'] },
};
